import React from 'react';

export const StarIcon = ({ className = '', fill = '#05F36C' }) => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 31 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        id="Vector"
        d="M14.0599 0.940126C14.5927 -0.313377 16.4074 -0.313375 16.9402 0.94013L20.0848 8.33853C20.3095 8.86698 20.8174 9.22805 21.4004 9.27378L29.5627 9.91412C30.9457 10.0226 31.5064 11.7114 30.4528 12.5946L24.234 17.8073C23.7898 18.1797 23.5957 18.764 23.7314 19.3206L25.6314 27.1148C25.9533 28.4353 24.4852 29.4791 23.3012 28.7715L16.3131 24.5947C15.8139 24.2963 15.1862 24.2963 14.687 24.5947L7.69885 28.7715C6.51484 29.4791 5.04674 28.4353 5.36864 27.1148L7.26862 19.3206C7.40433 18.764 7.21034 18.1797 6.76616 17.8073L0.547248 12.5946C-0.506414 11.7114 0.0543553 10.0226 1.4373 9.91412L9.59972 9.27378C10.1827 9.22805 10.6906 8.86698 10.9152 8.33853L14.0599 0.940126Z"
        fill={fill}
      />
    </svg>
  );
};
